import styled from 'styled-components'

type Props = {
  isExternal: boolean
  onToggle: (isExternal: boolean) => void
}

/** Internal/external segmented toggle in the brand style (accent fill, input radius). */
const PalletTypeToggle = ({ isExternal, onToggle }: Props) => (
  <Root role='group' aria-label='סוג משטח'>
    <Seg type='button' $active={!isExternal} onClick={() => onToggle(false)}>
      פנימי
    </Seg>
    <Seg type='button' $active={isExternal} onClick={() => onToggle(true)}>
      חיצוני
    </Seg>
  </Root>
)

export default PalletTypeToggle

const Root = styled.div`
  display: flex;
  width: 100%;
  gap: 0.25rem;
  padding: 0.25rem;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 0.875rem;
`

const Seg = styled.button<{ $active?: boolean }>`
  flex: 1;
  border: 0;
  cursor: pointer;
  padding: 0.625rem 0.5rem;
  border-radius: 0.625rem;
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: ${({ theme }) => theme.text.sm};
  font-weight: 600;
  background: ${({ theme, $active }) => ($active ? theme.colors.accent : 'transparent')};
  color: ${({ theme, $active }) => ($active ? theme.colors.ink : theme.colors.ink2)};
  transition: all ${({ theme }) => theme.motion.fast} ease;

  &:hover {
    color: ${({ theme }) => theme.colors.ink};
  }
`
